module.exports = __webpack_public_path__ + "img/ether.a9105819.png";